import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';


function ProtectedRoute(props)
{
    const {Component} = props;
    const navigate    = useNavigate(); 

    // use useEffect hook for make effect on route
    useEffect(()=>{
        let token = localStorage.getItem('token');
        // console.log(token);
        if(!token){
            navigate('/');
        }
    },[]);
    return (
        <div>
            <Component />
        </div>
    )
}

export default ProtectedRoute;